import type { NewClassGetItem } from '@whizz/api-model/src/endpoints/NewClass';

export const mapClassesForSelector = (newClasses: NewClassGetItem[]): { label: string, value: number }[] => {
  return newClasses.map((newClass): { label: string, value: number } => ({
    label: newClass.name,
    value: newClass.id,
  }));
};
